const loadingData = [
    {
        id: 'loading1',
        name: 'loading1',
        memberCount: 1,
        health: 95,
        featureCount: 4,
        createdAt: '',
        description: '',
    },
    {
        id: 'loading2',
        name: 'loading2',
        memberCount: 1,
        health: 95,
        featureCount: 4,
        createdAt: '',
        description: '',
    },
    {
        id: 'loading3',
        name: 'loading3',
        memberCount: 1,
        health: 95,
        featureCount: 4,
        createdAt: '',
        description: '',
    },
    {
        id: 'loading4',
        name: 'loading4',
        memberCount: 1,
        health: 95,
        featureCount: 4,
        createdAt: '',
        description: '',
    },
];

export default loadingData;
